import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { enquiryService } from "@/services/api/cresivoxServer";

import { REDUCER_NAME } from "./Types";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

// ─── GET ALL ENQUIRIES ────────────────────────────────────────────────────────
export const getEnquiries = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getEnquiries"),
  // @ts-expect-error: Type mismatch between schema and expected types
  async (arg, { rejectWithValue }) => {
    try {
      const response = await enquiryService.getAllEnquiries();
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  httpStatusCode,
                  data: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);